const url_webapi = process.env.REACT_APP_API;
let Backend = {

  UploadFiles: function UploadFiles(email, token, idGroup, fileType, fileName, totp, data64, callback) {
    fetch(url_webapi + 'webapiv0/upload_file/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "' + email + '","w03": "' + token + '","w04": {"function": "upload_file_sys","id_group": "' + idGroup + '","file_type": "' + fileType + '","file_name": "' + fileName + '","data": "' + data64 + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  PlanUpgradeNow: function PlanUpgradeNow(email, token, planSelected, cellphone, organizationName, country, state, streetAddress, zipCode, legalRepresentative, paymentSubscription, totp, callback) {
    fetch(url_webapi + 'webapiv0/upgrade_plan/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "' + email + '","w03": "' + token + '","w04": {"function": "upgrade_plan","plan_selected": "' + planSelected + '","cellphone": "' + cellphone + '","organization_name": "' + organizationName + '","country": "' + country + '","state": "' + state + '","street_address": "' + streetAddress + '","zip_code": "' + zipCode + '","legal_representative": "' + legalRepresentative + '","payment_subscription":"' + paymentSubscription + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  PlanCellphoneStatus: function PlanCellphoneStatus(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/cellphone_status/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "' + email + '","w03": "' + token + '","w04": {"function": "cellphone_status"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  PlanCellphoneValidation: function PlanCellphoneValidation(email, token, cellphone, verificationCode, country, totp, callback) {
    fetch(url_webapi + 'webapiv0/cellphone_status/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "' + email + '","w03": "' + token + '","w04": {"function": "cellphone_validation", "cellphone": "' + cellphone + '", "verification_code": "' + verificationCode + '", "country": "' + country + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  PricingPlansLogged: function PricingPlansLogged(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/available_plans_log/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "' + email + '","w03": "' + token + '","w04": {"function": "get_available_plan_logged"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  CreateOrderVirtualExchange: function CreateOrderVirtualExchange(email, token, pair, order_type, category, amount, id_wallet, totp, callback) {
    fetch(url_webapi + 'webapiv0/vexchange/createOrder/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_v_exchange","w02": "' + email + '","w03": "' + token + '","w04": {"function": "vex_create_order","pair":"' + pair + '","order_type":"' + order_type + '","category":"' + category + '","amount":"' + amount + '","id_wallet":"' + id_wallet + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  CreateOrderVirtualExchange2: function CreateOrderVirtualExchange2(
    email,
    token,
    coin_from,
    coin_to,
    id_wallet_from ,
    id_wallet_to,
    amount,
    totp,
    callback
    ) {
    fetch(url_webapi + 'webapiv0/vexchange/createOrder/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_v_exchange",
          "w02": email,
          "w03": token,
          "w04": {
            "function": "vex_create_order_new",
            "coin_from": coin_from,
            "coin_to": coin_to,
            "id_wallet_from": id_wallet_from,
            "id_wallet_to": id_wallet_to,
            "amount": amount,
          },
          "w05": totp
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  TransactionsVirtualExchange: function TransactionsVirtualExchange(email, token, filter_num, page, search_string, date_from, date_to, sort_filter, totp, callback) {
    fetch(url_webapi + 'webapiv0/vexchange/getVexTransactions/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_v_exchange","w02": "' + email + '","w03": "' + token + '","w04": {"function": "vex_transactions","filter_num":"' + filter_num + '","page":"' + page + '","search_string":"' + search_string + '","date_from":"' + date_from + '","date_to":"' + date_to + '","sort_filter":"' + sort_filter + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  BalanceVirtualExchange: function BalanceVirtualExchange(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/vexchange/getVexBalance/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_v_exchange","w02": "' + email + '","w03": "' + token + '","w04": {"function": "vex_balance", "cur": ["usd", "mxn"]},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  AvailablePairs: function AvailablePairs(totp, callback) {
    fetch(url_webapi + 'webapiv0/available_pairs/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "---","w03": "---","w04": {"function": "get_available_pairs"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  PricingPlans: function PricingPlans(totp, callback) {
    fetch(url_webapi + 'webapiv0/available_plans/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "---","w03": "---","w04": {"function": "get_available_plans"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  PricingAttributes: function PricingAttributes(callback) {
    fetch(url_webapi + 'webapiv0/available_plans_attrs/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "---","w03": "---","w04": {"function": "get_available_plans_attrs"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  TransactionPerAccount: function TransactionPerAccount(email, token, numFilter, page, totp, search, datefrom, dateto, sortFilter, callback) {
    fetch(url_webapi + 'webapiv0/transactions_list/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_transactions","w02": "' + email + '","w03": "' + token + '","w04": {"function": "transactions_list_complete","filter_num": "' + numFilter + '","page": "' + page + '","search_string": "' + search + '","date_from": "' + datefrom + '","date_to": "' + dateto + '","sort_filter": "' + sortFilter + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  FreezeWallet: function FreezeWallet(email, token, idWallet, key, captcha, dateFrom, dateTo, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_freeze_wallet/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallet_freezer","id_wallet": "' + idWallet + '","key": "' + key + '","captcha": "' + captcha + '","date_from": "' + dateFrom + '","date_to": "' + dateTo + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WalletDisabledEnabled: function WalletDisabledEnabled(email, token, idWallet, key, acc, captcha, action, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_lock_wallet/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallet_locker","id_wallet": "' + idWallet + '","key": "' + key + '", "acc": "' + acc + '","captcha": "' + captcha + '","action": "' + action + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  ChangeWalletAlias: function ChangePasswordWallet(email, token, idWallet, new_alias, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_wallet_change_alias/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallets_wallet_change_alias","id_wallet": "' + idWallet + '","new_alias": "' + new_alias + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  ChangePasswordWallet: function ChangePasswordWallet(email, token, keypassword, acc, captcha, idWallet, totp, twofa_code, callback) {
    fetch(url_webapi + 'webapiv0/wallets_reset_password/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallet_reset_password","key": "' + keypassword + '", "acc": "' + acc + '","captcha": "' + captcha + '","id_wallet": "' + idWallet + '","twofa_code": "' + twofa_code + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WalletPayCard: function WalletPayCard(email, token, idWallet, coin, amount, totp, password, twofa_code, callback) {
    fetch(url_webapi + 'webapiv0/wallets_new_withdrawal/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "transfer","type": "transfer_card_payment","password": "' + password + '" , "twofa_code": "'+twofa_code+'" , "data": {"from_wallet":"'+ idWallet +'", "amount":"'+ amount +'"}},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WalletNewWithdrawal: function WalletNewWithdrawal(email, token, idWallet, coin, amount, address, tagId, description, totp, password, twofa_code, callback) {
    fetch(url_webapi + 'webapiv0/wallets_new_withdrawal/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "transfer","type": "transfer_invoice","password": "' + password + '" , "twofa_code": "'+twofa_code+'" , "data": {"from_wallet":"'+ idWallet +'", "amount":"'+ amount +'","description": "'+ description +'","address":"'+ address +'"}},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  WalletNewWithdrawal2: function WalletNewWithdrawal2(email, token, idWallet, coin, amount, address, tagId, description, totp, password, twofa_code, net, callback) {
    fetch(url_webapi + 'webapiv0/wallets_new_withdrawal/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallet_new_withdraw","id_wallet": "' + idWallet + '","coin": "' + coin + '","amount": "' + amount + '","password": "' + password + '","address": "' + address + '","tag_id": "' + tagId + '","description": "' + description + '","twofa_code": "' + twofa_code + '", "net": "' + net + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },


  ChangeLabelWallets: function ChangeLabelWallets(email, token, alias, idAddress, idWallet, address, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_change_alias/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallet_address_change_alias","alias": "' + alias + '","id_address": "' + idAddress + '","id_wallet": "' + idWallet + '","address": "' + address + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  AddAddressInWallet: function AddAddressInWallet(email, token, idwallet, alias, amount, net, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_assign_address/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "assign_new_address","id_wallet": "' + idwallet + '","alias": "' + alias + '","amount": "' + amount + '", "net": "' + net + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WalletsPagination: function WalletsPagination(email, token, idwallet, numFilter, page, totp, search, sortFilter, callback) {
    fetch(url_webapi + 'webapiv0/wallets_list_info/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallet_list_information","id_wallet": "' + idwallet + '","filter_num": "' + numFilter + '","page": "' + page + '","search_string": "' + search + '","sort_filter": "' + sortFilter + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WalletsPaginationTransaction: function WalletsPaginationTransaction(email, token, idwallet, numFilter, page, totp, search, datefrom, dateto, sortFilter, callback) {
    fetch(url_webapi + 'webapiv0/wallets_transactions/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallets_transactions","id_wallet": "' + idwallet + '","filter_num": "' + numFilter + '","page": "' + page + '","search_string": "' + search + '","date_from": "' + datefrom + '","date_to": "' + dateto + '","sort_filter": "' + sortFilter + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WalletsInformation: function WalletsInformation(email, token, idwallet, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_info/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallet_information","id_wallet": "' + idwallet + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  CreateWallets: function CreateWallets(email, token, coin, alias, password, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_create_new/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "create_wallet","coin": "' + coin + '","alias": "' + alias + '","password": "' + password + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GetWallets: function GetWallets(email, token, searchString, page, filterNumber, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_per_user/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallets_per_user","search_string":"' + searchString + '", "page":"' + page + '", "filter_num":"' + filterNumber + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GroupInformationPlanInfo: function GroupInformationPlanInfo(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/wallets_limits/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "wallets_limits"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  DropdownCoin: function DropdownCoin(callback) {
    fetch(url_webapi + 'webapiv0/available_coins/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "---","w03": "---","w04": {"function": "get_available_coins","key": "---"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  availableCoins: function availableCoins(callback) {
    fetch(url_webapi + 'webapiv0/available_coins/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_general",
          "w02": "---",
          "w03": "---",
          "w04": {"function": "get_available_coins","key": "---"},
          "w05": "---"
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  availableCoins_rt: function availableCoins_rt(token, totp, email, callback) {
    fetch(url_webapi + 'webapiv0/available_coins/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_general",
          "w02": email,
          "w03": token,
          "w04": {"function": "get_available_coins_rt","key": "---"},
          "w05": totp
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  XrpAddress: function XrpAddress(token, totp, email, callback) {
    fetch(url_webapi + 'webapiv0/available_coins/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_wallets",
          "w02": email,
          "w03": token,
          "w04": {"function": 'xrp_address'},
          "w05": totp
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  RenovateToken: function RenovateToken(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/renew_session/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_login","w02": "' + email + '","w03": "' + token + '","w04": {"function": "renew_session_web","key": "' + totp + '"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  ConfirmationForgot: function ConfirmationForgot(email, token, key, recaptcha, callback) {
    fetch(url_webapi + 'webapiv0/reset_password/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_login","w02": "' + email + '","w03": "' + token + '","w04": {"function": "client_reset_password","key": "' + key + '","captcha": "' + recaptcha + '"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Forgot: function Forgot(email, country, key, recaptcha, callback) {
    fetch(url_webapi + 'webapiv0/forgot_password/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_login","w02": "' + email + '","w03": "---","w04": {"function": "client_forgot_password","email": "' + email + '","country": "' + country + '","captcha": "' + recaptcha + '","key": "' + key + '"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Check2FA: function Check2FA(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/check_2fa_status/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_general","w02": "' + email + '","w03": "' + token + '","w04": {"function": "check_2fa_status"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Login: function Login(email, sha3824, password, recaptcha, totp, twofa_code, callback) {
    fetch(url_webapi + 'webapiv0/login/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload":{
          "w01": 'g_login',
          "w02": email,
          "w03": sha3824,
          "w04": {
            "function":"clients_login",
            "email":email,
            "password":password,
            "captcha":recaptcha,
            "key":totp,
            "twofa_code":twofa_code
          },
          "w05": '---',
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  LoginOut: function Login(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/logout/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_login","w02": "' + email + '","w03": "' + token + '","w04": {"function": "clients_logout"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Confirm2FA: function Confirm2FA(email, sha3824, password, recaptcha, totp, twofa_code, callback) {
    fetch(url_webapi + 'webapiv0/login2fa/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_login","w02": "' + email + '","w03": "' + sha3824 + '","w04": {"function": "login2fa","email": "' + email + '","password": "' + password + '","captcha": "' + recaptcha + '","key": "' + totp + '","twofa_code": "' + twofa_code + '"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Register: function Register(key, email, firstname, lastname, country, recaptcha, callback) {
    fetch(url_webapi + 'webapiv0/register/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_login","w02": "' + email + '","w03": "---","w04": {"function": "register_new_client","email": "' + email + '","first_name": "' + firstname + '","last_name": "' + lastname + '","country": "' + country + '","key": "' + key + '","captcha": "' + recaptcha + '"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  RegisterWithCard: function Register(key, email, card, recaptcha, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
          "payload": {
              "w01": "g_login",
              "w02": "",
              "w03": "---",
              "w04": {
                  "function": "register_with_card",
                  "email": email,
                  "key": key,
                  "key_c": card,
                  "captcha": recaptcha
              },
              "w05": "---"
          }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Confirmation: function Confirmation(email, token, recaptcha, callback) {
    fetch(url_webapi + 'webapiv0/confirm_email/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_login","w02": "' + email + '","w03": "' + token + '","w04": {"function": "confirm_email","email": "' + email + '","captcha": "' + recaptcha + '"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  ResendConfirmation: function ResendConfirmation(email, country, key, recaptcha, callback) {
    fetch(url_webapi + 'webapiv0/resend_confirmation/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_login","w02": "' + email + '","w03": "---","w04": {"function": "resend_email_confirmation","email": "' + email + '","country": "' + country + '","key": "' + key + '","captcha": "' + recaptcha + '"},"w05": "---"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  InvoiceInfo: function InvoiceInfo(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/invoices/getInvoicePaymentAddresses/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_invoice","w02": "' + email + '","w03": "' + token + '","w04": {"function": "invoices_address_list"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  SingleInvoice: function SingleInvoice(email, token, totp, uuid, callback) {
    fetch(url_webapi + 'webapiv0/invoices/getInvoicePaymentAddresses/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_invoice","w02": "' + email + '","w03": "' + token + '","w04": {"function": "invoice_single","uuid": "' + uuid + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GetUserInfo: function GetUserInfo(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/getClientInfo/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "settings_client_info"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  GetUserInfo2: function GetUserInfo2(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/getGroupInfo/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "settings_group_info"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  VerifyAlias: function VerifyAlias(email, group_nick, mode,twofa_totp, token, totp, callback){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "group_nick", "group_nick":"'+group_nick+'","mode":"'+mode+'","2fa_totp":"'+twofa_totp+'"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })

  },

  GetGroupInfo: function GetGroupInfo(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/getClientInfo/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "settings_group_info"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  ChangeMainPass: function ChangeMainPass(email, token, okey, nkey, captcha, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/changePassword/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "change_password","okey": "' + okey + '","nkey": "' + nkey + '","captcha": "' + captcha + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Get2FA: function Get2FA(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/check2FAstatus/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "check_2fa"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Activate2FA: function Activate2FA(email, token, twoFA, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/validate2FAcode/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "validate_2fa", "2fa_totp":"' + twoFA + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Disable2FA: function Disable2FA(email, token, twoFA, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/validate2FAcode/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "disable_2fa", "2fa_totp":"' + twoFA + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GetAPIKeys: function GetAPIKeys(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/getAPIv1KeysList/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "get_apikeys_list"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  CreateAPIKey: function CreateAPIKey(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/getAPIv1KeysList/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "create_new_apikey"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GetAPISecret: function GetAPISecret(email, token, apikeyid, apikey, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/getAPIv1KeySecrets/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "get_apikeys_keys", "apikeyid":"' + apikeyid + '", "apikey":"' + apikey + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },


  ChangeAPIStatus: function ChangeAPIStatus(email, token, apikeyid, apikey, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/changeAPIv1Status/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_settings","w02": "' + email + '","w03": "' + token + '","w04": {"function": "change_apikey_status", "apikeyid":"' + apikeyid + '", "apikey":"' + apikey + '"},"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  InternalTransfer: function InternalTransfer(email, token, password, from_wallet, to_wallet, amount, totp, twofa_code, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "transfer", "type": "transfer_internal", "password":"' + password + '", "twofa_code": "'+twofa_code+'" ,"data": {"from_wallet": "' + from_wallet + '", "to_wallet": "' + to_wallet + '", "amount": "' + amount + '"} },"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  UserTransfer: function UserTransfer(email, token, password, from_wallet, amount, to_group_nick, to_wallet_alias, description, totp, twofa_code,callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "g_wallets","w02": "' + email + '","w03": "' + token + '","w04": {"function": "transfer", "type": "transfer_users_web", "password":"' + password + '", "twofa_code": "'+twofa_code+'" ,"data": {"from_wallet": "' + from_wallet + '", "amount": "' + amount + '", "to_group_nick": "' + to_group_nick + '", "to_wallet_alias": "' + to_wallet_alias + '", "description": "' + description + '"} },"w05": "' + totp + '"}}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },


  GetWhiteList: function GetWhiteList(email, token, search_coin, search_status, search_string, page, filter_num, totp,callback) {
    fetch(url_webapi + 'webapiv0/whitelist/getWhitelist/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_whitelist",
         "w02": email,
         "w03": token,
         "w04": {
             "function": "whitelist_list",
             "search_coin": search_coin,
             "search_status": search_status,
             "search_string": search_string,
             "page": page,
             "filter_num": filter_num
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WhiteListStatus: function WhiteListStatus(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_settings",
         "w02": email,
         "w03": token,
         "w04": {
             "function": "whitelist_change",
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WhiteListIncert: function WhiteListIncert(email, token, coin, address, tag_id, label, max_amount, twofa_code, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_whitelist",
         "w02": email,
         "w03": token,
         "w04": {
           "function": "whitelist_insert",
           "coin": coin,
           "address": address,
           "tag_id": tag_id,
           "label": label,
           "max_amount": max_amount,
           "twofa_code": twofa_code,
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  WhiteListUpdate: function WhiteListUpdate(email, token, id, tag_id, label, status, max_amount, twofa_code, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_whitelist",
         "w02": email,
         "w03": token,
         "w04": {
           "function": "whitelist_update",
           "id": id,
           "tag_id": tag_id,
           "label": label,
           "status": status,
           "max_amount": max_amount,
           "twofa_code": twofa_code,
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  FiatWithdrawl: function FiatWithdrawl(email, token, amount, uuid, totp, currency, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_v_exchange",
         "w02": email,
         "w03": token,
         "w04": {
            "function": "fiat_withdrawal",
            "amount": amount,
            "uuid": uuid,
            "coin": currency,
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  GetStatusCard: function GetStatusCard(email, token, totp, callback){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
           "function": "get_card_status"
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  RequestCard: function RequestCard(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
           "function": "new_card",
          //  "first_name": first_name,
          //  "last_name": last_name,
          //  "street_address": street_address,
          //  "state": state,
          //  "zip_code": zip_code
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  VerifyCard: function VerifyCard(email, token, bin_trunc, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
           "function": "verify_card",
	          "bin_trunc": bin_trunc
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GetCardBalance: function CardBalance(email, token, card_id ,totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
           "function": "card_balance",
           "id_card": card_id
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  GetCardsInfo: function GetCardsInfo(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "get_cards_info"
         },
         "w05": totp
       },
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GetVirtualKey: function GetVirtualKey(email,token, totp,idCard, type,callback ){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
            "function": "get_virtual_key",
            "id_card": idCard,
            "type": type
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GetCardData2: function GetCardData2(email,token, totp,idCard, type,callback ){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
            "function": "get_card_data",
            "id_card": idCard,
            "type": type
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  GetCardData: function GetVirtualKey(email,token, totp,idCard, type,callback ){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
            "function": "get_virtual_key",
            "id_card": idCard,
            "type": type
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },


  BlockCard: function BlockCard(email, token, action, card_id, type,totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
            "function": "card_blocker",
            "id_card": card_id,
	          "action": action,
            "type": type
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  DetectCardType: function DetectCardType(email, token, bin, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "detect_card_type",
          "bin": bin
         },
         "w05": totp
       }
      })
    })
    .then((response) => response.json())
    .then((responseJson) => {
      callback(responseJson)
    })
    .catch((error) => {
      console.log(error);
    })
  },
  GetCardTransactions: function GetCardTransactions(email, token, id_card,start_date, end_date, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "card_trans",
          "id_card": id_card,
          "start_date": start_date,
          "end_date": end_date,
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  RequestPin: function RequestPin(email, token, verification_code, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_cards",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "request_pin",
          "verification_code": verification_code,
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  CardDeposit: function CardDeposit(email, token, card_id, amount, coin, twofa_code, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_v_exchange",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "card_transfer_deposit",
          "id_card": card_id,
          "amount": amount,
          "coin": coin,
          "twofa_code":twofa_code
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  CardWithdrawal: function CardWithdrawal(email, token, card_id,amount, coin, twofa_code, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_v_exchange",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "card_transfer_withdrawal",
          "id_card": card_id,
          "amount": amount,
          "coin": coin,
          "twofa_code":twofa_code
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  register_client_data: function register_client_data(email, token,data, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_settings",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "register_client_data",
          ...data
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  get_reject_data: async function get_reject_data(email, token,type, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_settings",
          "w02": email,
          "w03": token,
          "w04": {
              "function": "get_kyc_client",
              "type_user": type
          },
          "w05": totp
      }
      })
    })
    .then((response) => response.json())
    .then((responseJson) => {
      callback(responseJson)
    })
    .catch((error) => {
      console.log(error);
    })
  },

  get_image:  function get_image(email, token, file, totp, callback) {
    fetch(url_webapi + 'webapiv0/images', {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json',
        },
        "body": JSON.stringify({
          "payload": {
            "w01": "g_general",
            "w02": email,
            "w03": token,
            "w04": {
              "function": "download_file",
              "file_name": file,
            },
            "w05": totp
        }
        })
      })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  upload_file: function upload_file(email, token, file, fileName ,totp, callback) {
    fetch(url_webapi + 'webapiv0/images', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_general",
         "w02": email,
         "w03": token,
         "w04": {
            "function": "upload_file",
            "file_type": file.base64Type,
            "file_name": fileName,
            "uuid" : "None",
            "data": file.base64
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  get_client_data: function get_client_data(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/clientData/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_settings",
         "w02": email,
         "w03": token,
         "w04": {
            "function": "get_client_data"
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  client_banks_list: function client_banks_list(email, token, filter, totp, callback) {
    fetch(url_webapi + 'webapiv0/settings/getBanksList/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_settings",
         "w02": email,
         "w03": token,
         "w04": {
            "function": "client_banks_list",
            "filter": filter
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  client_add_bank: function client_add_bank(email, token, bankData, uuid, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_settings",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "client_add_bank",
          "bank_country": bankData.bank_country,
          "bank_number_account": bankData.bank_number_account,
          "bank_currency": bankData.bank_currency,
          "bank_aba": bankData.bank_aba,
          "bank_swift": bankData.bank_swift,
          "bank_spid": bankData.bank_spid,
          "bank_clabe_account": bankData.bank_clabe_account,
          "uuid": uuid,
          "bank_name":bankData.bank_name,
          "bank_intermediary" :bankData.bank_intermediary,
          "bank_address"  :bankData.bank_address,
          "billing_address"  :bankData.billing_address,
          "zip_code"  :bankData.zip_code,
          "state"  :bankData.state,
          "city" :bankData.city,
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  client_remove_bank: function client_remove_bank(email, token, uuid, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_settings",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "client_remove_bank",
          "uuid": uuid
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  contract_card_info: async function contract_card_info(email, token, totp, callback) {
    try {
      const response = await fetch(url_webapi + 'webapiv0', {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json',
        },
        "body": JSON.stringify({
          "payload": {
           "w01": "g_cards",
           "w02": email,
           "w03": token,
           "w04": {
            "function": "card_contract_info"
           },
           "w05": totp
         }
        })
      })
      const json = await response.json();
      callback(json)
    } catch (error) {
      console.log(error);
    }
  },

  create_commerce: function create_commerce(email, token, totp, state, wallet_pass, callback) {
    let { ecomm_name, auto_vex, auto_fiat, fiat_interval, fiat_bank, url, currency } = state
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "create_ecomm",
          ecomm_name,
          wallet_pass,
          auto_vex,
          auto_fiat: auto_fiat || '',
          fiat_interval:fiat_interval || '',
          fiat_bank,
          url,
          currency
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  general_get: function general_get(function_name,totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": function_name,
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  update_ecomm_wallets: function update_ecomm_wallets(totp, coins_settings, callback){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": "change_wallets_settings",
          coins_settings
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  update_ecomm_notifications: function update_ecomm_notifications(totp, on_order_creation, on_order_complete, callback){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": "change_notifications_settings",
          "notifications":{
            on_order_creation,
            on_order_complete
          }
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  update_general_settings: function update_general_settings(totp, general_settings, callback){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": "change_general_settings",
          general_settings
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  get_orders_list: function get_orders_list(email, token, totp, state, callback) {
    let { date_from, date_to, page_size, page, search} = state
    date_from = (date_from)? date_from + ' 00:00:00' : ''
    date_to = (date_to)? date_to + ' 23:59:59' : ''
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "get_orders_list",
          date_from,
          date_to,
          page_size,
          page,
          search
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  get_order_info: function get_order_info(totp, id_order, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": "get_order_info",
          id_order: parseInt(id_order)
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },


  change_order_status: function change_order_status(totp, id_order, status, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": "change_order_status",
          id_order: parseInt(id_order),
          status
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  send_incomplete_order_email: function send_incomplete_order_email(email, token, totp, id_order, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": email,
         "w03": token,
         "w04": {
          "function": "send_incomplete_order_email",
          "id_order": parseInt(id_order),
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  get_ecomm_image: function get_ecomm_image(totp, callback) {
    fetch(url_webapi + 'webapiv0/images', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_general",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": 'download_file',
          file_name:'f_ecomm_logo'
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
	get_ecomm_checkout: function get_ecomm_checkout(totp, callback){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": "",
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": "get_ecomm_checkout",
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  ecomm_lead: function ecomm_lead(totp){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_ecomms",
          "w02": localStorage.getItem('email'),
          "w03": localStorage.getItem('token'),
          "w04": {
           "function": 'notify_create_ecomm'
          },
          "w05": totp
        }
      })
    }).catch((error) => {
        console.log(error);
      })
  },

  get_payment_address: function get_payment_address(totp, coin, email, shipping, callback){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {

         "w01": "g_ecomms",
         "w02": "",
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": "get_payment_address",
          coin,
          email,
          shipping
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

client_language: function client_language(lang, totp, callback) {

    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_settings",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": 'client_language',
          lang_choosen:lang
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  get_services_list: function get_services_list( totp, callback) {

    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_services",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": 'get_services_list'
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  transfer_service_payment: function transfer_service_payment( info, Twofa ,totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_services",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": 'transfer_service_payment',
          "coin": info.coin,
          "amount": info.amount,
          "id_service":info.id_service,
          "service_amount": info.service_amount,
          "reference":info.Reference,//"018400712007261812170000015173",//info.Reference
          "from_wallet": info.from_wallet,
          "key":info.key, //password wallet
          "twofa_code":Twofa
         },
         "w05": totp
       }
      })
    })
    .then((response) => response.json())
    .then((responseJson) => {
      callback(responseJson)
    })
    .catch((error) => {
      console.log(error);
    })
  },
  get_transactions_list: function get_transactions_list( totp, callback) {

    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_services",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
            "function": 'get_transactions_list',
            "date_from": "",
            "date_to": ""
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  getClabeForSTP: function getClabeForSTP(totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },

      body: `{
        "payload": {
          "w01": "g_v_exchange",
          "w02": ${JSON.stringify(localStorage.getItem('email'))},
          "w03": ${JSON.stringify(localStorage.getItem('token'))},
          "w04": {
            "function": "get_stp_info"
          },
          "w05": "${totp}"
        }
      }
      `,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson);
      })
      .catch((error) => {
        console.error('in getClabeForSTP: ', error);
      });
  },

  get_ecomm_devices: function get_ecomm_devices(totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
            "function": 'get_terminals_list',
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  activate_device: function activate_device(totp, state, callback) {
    let { name, user_name, currency, digit1, digit2, digit3, digit4, digit5, digit6 } = state
    let tag = digit1 + digit2 + digit3 + digit4 + digit5 + digit6;
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
            "function": 'activate_terminal',
            name,
            user_name,
            tag,
            currency
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  delete_ecomm_device: function delete_ecomm_device(totp, id_terminal, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
            "function": 'delete_terminal',
            id_terminal
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  change_device_status: function change_device_status(totp, id_terminal, status, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
            "function": 'change_terminal_status',
            id_terminal,
            status
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  change_thats_it_settings: function change_thats_it_settings(totp, thats_it_settings, callback){
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
         "w01": "g_ecomms",
         "w02": localStorage.getItem('email'),
         "w03": localStorage.getItem('token'),
         "w04": {
          "function": "change_thats_it_settings",
          ...thats_it_settings
         },
         "w05": totp
       }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  RequestRiseLimit: async function RequestRiseLimit(email, token, cardId,amount, reason, totp, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_cards",
          "w02": email,
          "w03": token,
          "w04": {
              "function": "increase_limit",
              "id_card": cardId,
              "new_limit": amount,
              "description": reason
          },
          "w05": totp
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  getCryptoBuyInfo: async function getCryptoBuyInfo(email, token, totp, callback) {
    fetch(url_webapi + 'webapiv0/vexchange/getCryptoBuy/', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_v_exchange",
          "w02": email,
          "w03": token,
          "w04": {
            "function": "get_crypto_buy_info",
          },
          "w05": totp
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  sendContractCryptoBuy: async function sendContractCryptoBuy(email, token, totp, contract, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_general",
          "w02": email,
          "w03": token,
          "w04": {
            "function": "upload_file",
            "file_type": "pdf",
            "file_name": "f_crypto_buy",
            "uuid" : "None",
            "data": contract
 
          },
          "w05": totp
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
  confirmBuyCryptoCard: async function confirmBuyCryptoCard(email, token, totp, amount, idWallet, coin, callback) {
    fetch(url_webapi + 'webapiv0', {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": JSON.stringify({
        "payload": {
          "w01": "g_v_exchange",
          "w02": email,
          "w03": token,
          "w04": {
            "function": "crypto_buy",
            "amount": amount,
            "id_wallet": idWallet,
            "coin": coin
          },
          "w05": totp
        }
      })
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },
};
export default Backend
